import { Component, Input, OnInit } from '@angular/core';
import { SeoContentSurveyService } from '../../../../services/seo-content-survey.service';
import { finalize } from 'rxjs';

@Component({
	selector: 'app-components-specialist-actioncomponents-seo-content-survey',
	templateUrl: './seo-content-survey.component.html'
})
export class SeoContentSurveyComponent implements OnInit {
    @Input() customerId: number;

    loading = true;
    seoContentSurvey: Boo.Objects.SeoContentSurvey;

    constructor(private seoContentSurveyService: SeoContentSurveyService) {}

    ngOnInit(): void {
      this.seoContentSurveyService.getByCustomerId(this.customerId)
      .pipe(
        finalize(() => this.loading = false)
      )
      .subscribe({
        next: (survey) => {
          this.seoContentSurvey = survey;
        }
      });
    }
}
